"use client"

import Image from "next/image";
import { useState, useEffect } from "react";

const PredictAttackSection = ({ screenWidth, accordian = [] }) => {
  const [selectedOption, setSelectedOption] = useState({
    id:"",
    title:"",
    description:"",
    images:[""],
    logo:"",
    learnMoreLink:""
  });

  const [animationState, setAnimationState] = useState("fadeIn"); // 'fadeOut' or 'fadeIn'
  const [options, setOptions] = useState([]);

  const heading= accordian.find(item=>item.component=="Heading") || {};

  useEffect(() => {
    if (animationState === "fadeOut") {
      const timeout = setTimeout(() => setAnimationState("fadeIn"), 300); // Trigger fadeIn after fadeOut
      return () => clearTimeout(timeout);
    }
  }, [animationState]);

  useEffect(() => {
    setOptions(() => {
      return accordian?.filter(item=>item.component=="accordian-item")?.map((item, index) => {
        const o = {
          id: item._uid,
          title: item.heading,
          description: item.description,
          images: [item.image?.filename],
          logo: item.icon?.filename,
          learnMoreLink:item.url?.cached_url
        }
        if (index == 0) {
          setSelectedOption(o)
        }
        return o
      })
    })
  }, [accordian])

  const handleOptionChange = (option) => {
    if (option.id !== selectedOption.id) {
      setAnimationState("fadeOut");
      setTimeout(() => setSelectedOption(option), 300); // Change option after fadeOut is complete
    }
  };

  return (
    <div className="lg:mt-20 lg:mt-[51px] relative w-[100%] asmBgBottomBG">
      {/* Header Section */}
      <div className="text-center max-w-5xl mx-auto">
        <h1 className="p-8 lg:p-0 font-aileron text-[28px] lg:text-[64px] font-bold bg-custom-radial bg-clip-text text-transparent">
         {heading.header}
        </h1>
        <p className="px-10 lg:px-0 mt-4 text-[18px] text-gray-600">
          {heading.subheader}
        </p>
      </div>

      {/* Main Section */}
      <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-12 px-6 lg:px-20 py-10 items-start mt-12 max-w-7xl m-auto">
        <div
          className="h-[100%] w-[80%] lg:w-[61%] left-[454px] 2xl:w-[68%] absolute  drop-shadow-lg hidden lg:block"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.4)", // Translucent white background with 60% opacity
            padding: "1rem", // Optional: Adjust the padding if needed
            borderRadius: "8px", // Optional: Add rounded corners if you want
          }}
        />
        {/* Left: Images */}
        <div className="relative space-y-4 lg:top-0 w-[100%] h-full flex items-center justify-center">
          {selectedOption.images.map((image, index) => (
            image && <img
              key={index}
              src={image}
              alt={`Preview ${index + 1}`}
              className={`rounded-lg mx-auto w-full transition-opacity transform duration-500 ease-in-out ${animationState === "fadeOut"
                ? "opacity-0 scale-95"
                : "opacity-100 scale-100"
                }`}
            />
          ))}
        </div>

        {/* Right: Feature Options */}
        <div className="relative">
          {/* Vertical Scrollbar */}
          <div className="absolute lg:top-0 top-10 left-0 z-1 w-1 bg-gray-200 h-[45%] flex items-center">
            <div
              className="w-1 rounded bg-purple-700"
              style={{
                // height: screenWidth >= 1024 ? `${100 / options.length}%`: `${80 / options.length}%`, // Adjust scrollbar size
                height:
                  screenWidth >= 1024 ? `244.43px` : `${80 / options.length}%`,
                backgroundColor: "#b7a5ec",
                transform:
                  screenWidth >= 1024
                    ? `translateY(${(options.indexOf(selectedOption) /
                      (options.length - 1)) *
                    130
                    }%)`
                    : `translateY(${(options.indexOf(selectedOption) /
                      (options.length - 1)) *
                    380
                    }%)`,
                transition: "transform 0.5s ease-in-out",
              }}
            ></div>
          </div>

          {/* Options List */}
          <div className="space-y-4 lg:pl-6 bg-[#f7f8fd] lg:py-0 lg:px-0 lg:bg-inherit py-10 px-4 lg:rounded-none rounded-lg shadow-xl lg:shadow-none ">
            {options.map((option) => (
              <div
                key={option.id}
                className={`p-2 xl:p-6 rounded-lg cursor-pointer transition-all duration-300`}
                onClick={() => handleOptionChange(option)}
              >
                {/* <div
                                    key={option.id}
                                    className={`p-6 rounded-lg cursor-pointer transition-all duration-300 ${selectedOption.id === option.id
                                        ? "border-l-4 border-purple-700 "
                                        : "border-l-4 border-transparent hover:shadow-lg"
                                        }`}
                                    onClick={() => handleOptionChange(option)}
                                > */}
                {selectedOption.id === option.id && (
                  <div
                    className="rounded-full h-[80px] w-[80px] lg:mb-3"
                  // style={{
                  //   background:
                  //     "radial-gradient(52% 52% at 50% 50%, #FFFFFF 0%, #DFD7EF 100%)",
                  // }}
                  >
                    <img src={option.logo} className="h-[80px] w-[80px]" />
                    {/* <img src={radarCircle} className="absolute top-0 left-0 h-[83px] w-[84px] bg-transparent" /> */}
                  </div>
                )}
                <h2
                  className={`text-2xl font-lato font-bold ${selectedOption.id !== option.id ? '!text-[#545454]' : 'text-inherit'}`}
                >
                  {option.title}
                </h2>
                {selectedOption.id === option.id && (
                  <div className="mt-2 text-gray-600 font-lato">
                    <p>{option.description}</p>
                    <a
                      href={option.learnMoreLink}
                      className="text-orange-500 hover:underline font-medium mt-2 inline-block"
                    >
                      Learn More
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PredictAttackSection;
